import { TextFieldProps, TextField as ShellTextField } from '@e3dc-react/shell/Elements/InputFields/TextField'
import React, { forwardRef } from 'react'
import { useField, useFormikContext } from 'formik'
import { useMediaQuery, useTheme } from '@mui/material'
import TextFieldBase from './TextFieldBase'

interface LocalProps extends TextFieldProps {
  name: string
  withTrim?: boolean
  mask?: string
}

const TextField = forwardRef<typeof ShellTextField, LocalProps>((props, ref) => {
  const { breakpoints } = useTheme()
  const downSm = useMediaQuery(breakpoints.down('sm'))
  const { handleBlur, handleChange: handleFieldChange } = useFormikContext()
  const [, field] = useField(props.name)

  const handleFocus = (event: React.FocusEvent<HTMLInputElement>): void => {
    if (downSm) event.target.select()
  }

  return (
    <TextFieldBase
      {...props}
      onChange={(value, fieldName) => handleFieldChange(fieldName)(value)}
      onFocus={handleFocus}
      onBlur={handleBlur}
      value={field.value}
    />
  )
})

TextField.displayName = 'TextField'

export default TextField
